import React from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Location from './components/Location';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="App">
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <Location />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
